export default __webpack_public_path__ + "static/media/book3.52f39d5a.png";